import React from "react";
import "./ValueDisplay.scss";
import ControlButton from "../ControlButton/ControlButton";

interface ValueDisplayProps {
  title: string;
  value: string;
  unit: string;
  onIncrement: () => void;
  onDecrement: () => void;
}

const ValueDisplay = ({
  title,
  value,
  unit,
  onIncrement,
  onDecrement,
}: ValueDisplayProps) => {
  return (
    <div className={`value-display ${title.toLowerCase()}`}>
      <h2 className="value-title">{title}</h2>
      <div className="value-container">
        <div className="value-panel" aria-label="Current Value">
          <div className="value-text">{value}</div>
        </div>
        <div className="controls-panel">
          <ControlButton direction="up" onClick={onIncrement} />
          <div className="unit-display">{unit}</div>
          <ControlButton direction="down" onClick={onDecrement} />
        </div>
      </div>
    </div>
  );
};

export default ValueDisplay;
